import React, { Component } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Row, Col } from 'react-bootstrap';
import { Section, Select, Loader, Modal, ViewModeSelector } from 'sa-ui';

import YearTabs from '../app/common/YearTabs';

import ClassesStudentsCard from './ClassesStudentsCard';
import ClassesStudentsAddCard from './ClassesStudentsAddCard';
import AddClassModal from './AddClassModal';
import NotifyStudentModal from './NotifyStudentModal';
import ClassesStudentsUploadAnswerCardModal from './answerCard/ClassesStudentsUploadAnswerCardModal';
import ClassesStudentsUploadAnswerConfirmationModal from './answerCard/ClassesStudentsUploadAnswerConfirmationModal';

import * as helpers from './classesStudentsHelpers';

import {
  getGroups,
  getSchools,
  massiveLoadGroups,
  resetMassiveLoadGroups,
  removeGroup,
  filterClasses,
  sendStudentEmail,
} from './classesStudentsActions';

import { newGroup, getGroupInformation } from './edit/editClassActions';

import messages from './classesStudentsMessages';

import './ClassesStudentsContainer.scss';
import RemoveConfirmationModal from './ClassesStudentsRemoveConfirmationModal';

class ClassesStudentsContainer extends Component {
  static getDerivedStateFromProps(props, state) {
    if (props.schools.length === 1 && !state.params.idCSchool) {
      return { params: { ...state.params, idCSchool: props.schools[0].idCSchool } };
    }
    if (props.years !== state.prevYears) {
      return {
        params: { ...state.params, year: props.years[0] },
        prevYears: props.years,
      };
    }
    if (props.years.length < 1 && state.prevYears.length < 1) {
      return {
        params: { ...state.params, year: new Date().getFullYear().toString() },
        prevYears: props.years,
      };
    }
    return null;
  }

  state = {
    params: {
      idCSchool: undefined,
      levelName: undefined,
      period: undefined,
      year: new Date().getFullYear().toString(),
    },
    page: 1,
    limit: 6,
    modals: {},
    uploadAnswerCardModalIsOpen: false,
    uploadAnswerCardConfirmationModalIsOpen: false,
    groupsFiltered: [],
    groupsPaginated: [],
    levelOptions: [],
    periodOptions: [],
    removeGroupError: false,
    idESCourseSelected: null,
    idCSchoolSelected: null,
    notifyPending: false,
  };

  async componentDidMount() {
    await this.props.getGroups({ frontGroups: true });
    await this.props.getSchools();

    setTimeout(() => {
      if (this.state.params.year) {
        const currentYear =
          this.state.params.year.toString() === new Date().getFullYear().toString();
        const firstPage = this.state.page === 1;
        const limit = firstPage && this.props.coordinator && currentYear ? 5 : 6;
        const offset = !firstPage && this.props.coordinator && currentYear ? 1 : 0;
        const groupsFiltered = helpers.filterGroups(this.props.groups, this.state.params);
        const groupsPaginated = helpers.paginate(groupsFiltered, this.state.page, limit, offset);
        const levelOptions = helpers.getLevelOptions(this.props.groups, this.state.params);
        const periodOptions = helpers.getPeriodOptions(this.props.groups, this.state.params);

        this.setState({ groupsFiltered, groupsPaginated, levelOptions, periodOptions });
      }
    }, 1000);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.groups !== this.props.groups ||
      prevState.page !== this.state.page ||
      prevState.params.year !== this.state.params.year ||
      prevState.params.idCSchool !== this.state.params.idCSchool ||
      prevState.params.levelName !== this.state.params.levelName ||
      prevState.params.period !== this.state.params.period
    ) {
      if (this.state.params.year) {
        const currentYear =
          this.state.params.year.toString() === new Date().getFullYear().toString();
        const firstPage = this.state.page === 1;
        const limit = firstPage && this.props.coordinator && currentYear ? 5 : 6;
        const offset = !firstPage && this.props.coordinator && currentYear ? 1 : 0;
        const groupsFiltered = helpers.filterGroups(this.props.groups, this.state.params);
        const groupsPaginated = helpers.paginate(groupsFiltered, this.state.page, limit, offset);
        const levelOptions = helpers.getLevelOptions(this.props.groups, this.state.params);
        const periodOptions = helpers.getPeriodOptions(this.props.groups, this.state.params);
        this.setState({ groupsFiltered, groupsPaginated, periodOptions, levelOptions });
      }
    }

    if (
      this.state.notifyPending &&
      prevProps.isLoadingGroupInformation &&
      !this.props.isLoadingGroupInformation
    ) {
      this.setState({
        modals: { ...this.state.modals, notifyStudentModal: true },
        notifyPending: false,
      });
    }

    if (prevProps.sendedEmail !== this.props.sendedEmail) {
      console.log('this.props.sendedEmail', this.props.sendedEmail);

      this.setState({
        modals: {
          ...this.state.modals,
          notifyStudentModal: false,
          notifyStudentConfirmationModal: true,
        },
        page: 1,
      });
    }
  }

  handleChangeFilter = (name) => (eventOrValue) => {
    const value = eventOrValue.target ? eventOrValue.target.value : eventOrValue;
    const overrides = name === 'idCSchool' ? { levelName: undefined, period: undefined } : {};
    this.setState({
      params: {
        ...this.state.params,
        [name]: value,
        ...overrides,
      },
      page: 1,
    });
  };

  handleChangeState = (name) => (eventOrValue) => {
    const value = eventOrValue.target ? eventOrValue.target.value : eventOrValue;

    if (name === 'page') {
      return this.setState({
        [name]: value,
      });
    }

    this.setState({
      params: {
        ...this.state.params,
        [name]: value,
      },
      page: 1,
    });
  };

  toggleModal =
    (name, visible = true) =>
    () => {
      this.setState({ modals: { ...this.state.modals, [name]: visible }, removeGroupError: false });
    };

  handleManualRegister = () => {
    this.setState({
      modals: { ...this.state.modals, addClassModal: false },
    });
    setTimeout(() => {
      this.props.newGroup();
      this.props.history.push('/groups/add');
    }, 500);
  };

  handleContinue = ({ file, school }) => {
    const formData = new FormData();
    formData.append('idCSchool', school);
    formData.append('file', file);

    this.props.massiveLoadGroups(formData);
  };

  handleRequestDelete = (group) => {
    this.setState({
      group,
      modals: { ...this.state.modals, removeConfirmation: true },
    });
  };

  handleDelete = async () => {
    await this.props.removeGroup({ idESCourse: this.state.group.idESCourse });

    setTimeout(() => {
      if (!this.props.removeGroupError) {
        this.setState({
          modals: { ...this.state.modals, removeConfirmation: false },
          page: 1,
        });
        window.location.reload(false);
      } else {
        this.setState({
          removeGroupError: this.props.removeGroupError,
        });
      }
    }, 3000);
  };

  handleClickCard = (group) => {
    if (!this.props.coordinator) {
      this.props.history.push(`/groups/${group.idESCourse}`);
    }
  };

  handleNotify = (group) => {
    this.props.getGroupInformation({ idESCourse: group.idESCourse });
    this.setState({
      page: 1,
      idESCourseSelected: group.idESCourse,
      idCSchoolSelected: group.idCSchool,
      notifyPending: true,
    });
  };

  render() {
    const {
      schools,
      massiveGroup,
      intl,
      isLoading,
      isLoadingGroupInformation,
      schoolOptions,
      hasError,
    } = this.props;
    const { groupsFiltered, groupsPaginated, levelOptions, periodOptions } = this.state;

    return (
      <Section>
        <Loader show={isLoading || isLoadingGroupInformation} />
        <Row className="mb-5">
          <Col lg={11}>
            <Row>
              <Col>
                <FormattedMessage {...messages.title}>
                  {(txt) => <h1 className="page-title">{txt}</h1>}
                </FormattedMessage>
              </Col>
              {/* <Col>
                <Select
                  containerClassName="mt-0"
                  placeholder={intl.formatMessage(messages.application)}
                  onChange={this.handleChangeFilter('application')}
                  options={this.props.applicationOptions}
                />
              </Col> */}
              {/* <Col>
                <Select
                  containerClassName="mt-0"
                  placeholder={intl.formatMessage(messages.status)}
                  onChange={this.handleChangeFilter('selectStatus')}
                  options={this.props.statusOptions}
                />
              </Col> */}
              {(schools.length > 1 || schoolOptions.length) !== 1 && (
                <Col>
                  <Select
                    containerClassName="mt-0"
                    placeholder={intl.formatMessage(messages.filterSchool)}
                    nullable={schoolOptions.length !== 1}
                    onChange={this.handleChangeFilter('idCSchool')}
                    value={this.state.params.idCSchool}
                    options={schoolOptions}
                  />
                </Col>
              )}
              <Col>
                <Select
                  containerClassName="mt-0"
                  placeholder={intl.formatMessage(messages.filterLevel)}
                  onChange={this.handleChangeFilter('levelName')}
                  disabled={!this.state.params.idCSchool}
                  options={levelOptions}
                />
              </Col>
              <Col>
                <Select
                  containerClassName="mt-0"
                  placeholder={intl.formatMessage(messages.filterPeriod)}
                  disabled={!this.state.params.idCSchool}
                  onChange={this.handleChangeFilter('period')}
                  options={periodOptions}
                />
              </Col>
            </Row>
          </Col>
          {/* <Col>
            <Row className="justify-content-md-end p-0 m-0">
              <ViewModeSelector />
            </Row>
          </Col> */}
        </Row>
        <YearTabs
          year={this.state.params.year}
          years={this.props.years}
          page={this.state.page}
          pages={Math.ceil((groupsFiltered.length + 1) / this.state.limit)}
          onChangePage={this.handleChangeState('page')}
          onChangeYear={this.handleChangeState('year')}
        />
        <Row>
          {this.state.params.year &&
            this.state.params.year === new Date().getFullYear().toString() &&
            this.state.page === 1 &&
            (this.props.canEditSchool || this.props.hasAccessToDemoSchool) && (
              // this.props.coordinator &&
              <Col lg={4} className="d-flex">
                <ClassesStudentsAddCard onClick={this.toggleModal('addClassModal')} />
              </Col>
            )}
          {groupsPaginated.map((d) => (
            <Col key={d.id} className="d-flex" lg={4}>
              <ClassesStudentsCard
                {...d}
                coordinator={this.props.coordinator}
                isCurrentYear={this.state.params.year === new Date().getFullYear().toString()}
                style={{ paddingBottom: '15px' }}
                onClick={() => this.handleClickCard(d)}
                onDelete={() => this.handleRequestDelete(d)}
                onEdit={() => this.props.history.push(`/groups/${d.idESCourse}`)}
                onNotify={() => this.handleNotify(d)}
                canEdit={this.props.canEditSchool}
                hasAccessToDemoSchool={this.props.hasAccessToDemoSchool}
              />
            </Col>
          ))}
        </Row>
        <RemoveConfirmationModal
          show={this.state.modals.removeConfirmation}
          onClose={this.toggleModal('removeConfirmation', false)}
          onContinue={this.handleDelete}
          error={this.state.removeGroupError}
        />
        <AddClassModal
          show={this.state.modals.addClassModal}
          schools={schools}
          onManualRegister={this.handleManualRegister}
          onContinue={this.handleContinue}
          onClose={this.toggleModal('addClassModal', false)}
          massiveGroup={massiveGroup}
          reset={this.props.resetMassiveLoadGroups}
          getGroups={this.props.getGroups}
          getSchools={this.props.getSchools}
          warnings={this.props.massiveGroup.warnings}
          error={this.props.massiveGroup.error}
          canEditSchool={this.props.canEditSchool}
          hasAccessToDemoSchool={this.props.hasAccessToDemoSchool}
        />
        <NotifyStudentModal
          show={this.state.modals.notifyStudentModal}
          onContinue={(students) =>
            this.props.sendStudentEmail({
              idCSchool: this.state.idCSchoolSelected,
              idESCourse: this.state.idESCourseSelected,
              studentsIds: students,
            })
          }
          onClose={this.toggleModal('notifyStudentModal', false)}
          students={this.props.students}
          hasError={hasError}
        />

        <ClassesStudentsUploadAnswerCardModal
          isOpen={this.state.uploadAnswerCardModalIsOpen}
          onClose={() => {
            this.props.resetCorrection();
            this.setState({ uploadAnswerCardModalIsOpen: false });
          }}
          onContinueCallback={() =>
            this.setState({ uploadAnswerCardConfirmationModalIsOpen: true })
          }
          onUpload={(file) => {
            const formData = new FormData();
            formData.append('idEvaluation', this.props.idEvaluation);
            formData.append('idCSchool', this.state.params.idCSchool);
            formData.append('idCourse', this.state.group.idESCourse);
            formData.append('file', file);
            this.props.correctAnswerSheet(formData);
          }}
          isLoading={this.props.isLoading}
          correctionInProgress={this.props.correctionInProgress}
          correctionFinalized={this.props.correctionFinalized}
          correctionResponse={this.props.correctionResponse}
          setCorrectionInProgress={this.props.setCorrectionInProgress}
          setCorrectionFinalized={this.props.setCorrectionFinalized}
          setCorrectionResponse={this.props.setCorrectionResponse}
          setLoading={this.props.setLoading}
          resetCorrection={this.props.resetCorrection}
        />
        <ClassesStudentsUploadAnswerConfirmationModal
          isOpen={this.state.uploadAnswerCardConfirmationModalIsOpen}
          onClose={() => this.setState({ uploadAnswerCardConfirmationModalIsOpen: false })}
          amount={this.props.correctionsWithSuccess}
        />

        <Modal
          show={this.state.modals.notifyStudentConfirmationModal}
          onClose={this.toggleModal('notifyStudentConfirmationModal', false)}
          icon="ti-thumb-up"
          title={intl.formatMessage(messages.notifyStudentConfirmation)}
          buttons={[
            {
              label: intl.formatMessage(messages.close),
              onClick: this.toggleModal('notifyStudentConfirmationModal', false),
            },
          ]}
        />
      </Section>
    );
  }
}

ClassesStudentsContainer.defaultProps = {
  years: [new Date().getFullYear().toString()],
};

function mapStateToProps({ app, classesStudents, editClass }) {
  return {
    user: app.user,
    coordinator: app.coordinator,
    canEditSchool: app.canEditSchool,
    hasAccessToDemoSchool: app.hasAccessToDemoSchool,
    ...classesStudents,
    ...editClass,
    schoolOptions: classesStudents.schoolOptions,
  };
}

export default compose(
  injectIntl,
  withRouter,
  connect(mapStateToProps, {
    getGroups,
    getSchools,
    massiveLoadGroups,
    resetMassiveLoadGroups,
    removeGroup,
    filterClasses,
    newGroup,
    getGroupInformation,
    sendStudentEmail,
  }),
)(ClassesStudentsContainer);
